<template>
  <div class="home">
    <b-container>
      <div class="page">
        <h2 class="page__title">{{ page.title }}</h2>

        <div class="page__description" v-html="page.description"></div>

        <div class="page__content" v-html="parseImageLink(page.detail)"></div>
      </div>
    </b-container>
  </div>
</template>

<script>
import { checkResponse, get } from "@/utils/http";
import { APP_CONFIG } from "@/utils/constants";

export default {
  name: "Page",
  data() {
    return {
      slug: this.$route.params.slug,
      page: {},
      cdnUrl: APP_CONFIG.cdnUrl
    };
  },
  methods: {
    async getPageContent() {
      return await get(`${APP_CONFIG.apiUrl}/page/${this.slug}`)
        .then(checkResponse)
        .then(response => {
          if (response.data.status == "error") {
            this.$router.push({ name: "home" });
          }
          this.page = response.data.data;
        })
        .catch(() => {
          this.error = true;
        });
    },
    parseImageLink(content) {
      if (content) {
        return content.replace(/<img src="..\/..\//g, `<img src="${this.cdnUrl}/`)
      }
    }
  },
  mounted() {
    this.getPageContent();
  },
  metaInfo() {
    return {
      title: this.page.meta_title || this.page.title,
      meta: [
        {
          vmid: "description",
          name: "description",
          content: this.page.meta_description
        },
        { vmid: "keywords", name: "keywords", content: this.page.meta_keyword },
        { vmid: "robots", name: "robots", content: "index, follow" },
        // OPG
        {
          property: "og:title",
          content: this.page.meta_title || "TRYHSK Online"
        },
        { property: "og:site_name", content: "TRYHSK Online" },
        // The list of types is available here: http://ogp.me/#types
        { property: "og:type", content: "website" },
        { property: "og:url", content: `${process.env.BASE_URL}` },
        { property: "og:description", content: this.page.meta_description }
      ],
      link: [
        {
          rel: "canonical",
          href: `${process.env.BASE_URL}noi-dung/${this.page.slug}`
        }
      ]
    };
  }
};
</script>
